import { render, staticRenderFns } from "./EqifyMenuItem.vue?vue&type=template&id=6c9b43b9"
import script from "./EqifyMenuItem.vue?vue&type=script&lang=ts"
export * from "./EqifyMenuItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports